import * as React from 'react'
import { ComponentExt } from 'util/reactExt'
import { Modal, Button, Table } from 'antd'
import { inject, observer } from 'mobx-react'
import styles from './index.scss'
import RoleOperationModal from 'containers/views/Levelup/RoleOperationModal'
import StaffOperationModal from 'containers/views/Levelup/StaffOperationModal'
import { levelStrategies } from 'store/LevelStore'

const ButtonGroup = Button.Group
const confirm = Modal.confirm
interface ICheckSettingsModalProps {
  levelStore?: any
  lessons: any[]
  checkActiveLessonID: string | number
  getCheckRoles: (param) => any
}

interface ICheckSettingsModalState {
  showRoleOperation: boolean
  showStaffOperation: boolean
  checkRoles: any[]
  checkRolesMeta: any
  loading: boolean
  filter: any
  activeLesson: any
  activeRole: any
}

@inject('globalStore', 'levelStore')
@observer
export default class CheckSettingsModal extends ComponentExt<
  ICheckSettingsModalProps,
  ICheckSettingsModalState
> {
  state = {
    showRoleOperation: false,
    showStaffOperation: false,
    checkRoles: [],
    checkRolesMeta: null,
    loading: false,
    activeLesson: { id: 0, name: '' },
    activeRole: null,
    filter: {
      page: 1,
      per_page: 8,
    },
  }

  private staffOperationModalRef

  async componentDidMount() {}

  async componentDidUpdate(prevProps) {
    if (prevProps.lessons.length !== this.props.lessons.length) {
      const activeLesson = this.props.lessons[0]
      this.setState(
        {
          activeLesson,
          // acitveRole:
          filter: {
            ...this.state.filter,
            lesson_id: activeLesson.id,
          },
        },
        () => this.getCheckRoles(),
      )
    }
  }

  toggleTableLoading = () => this.setState({ loading: !this.state.loading })

  // 请求数据列表
  getCheckRoles = async (): Promise<any> => {
    const {
      levelStore: { getEntityList },
    } = this.props
    this.toggleTableLoading()
    await getEntityList(levelStrategies.DEPARTMENT_ROLES, this.state.filter)
    this.toggleTableLoading()
  }

  switchLesson = async (lesson): Promise<any> => {
    this.setState(
      {
        activeLesson: lesson,
        filter: {
          ...this.state.filter,
          lesson_id: lesson.id,
          page: 1,
        },
      },
      () => this.getCheckRoles(),
    )
  }

  addRole = () => {
    this.setState({ showRoleOperation: true })
  }

  toggleRoleOperation = () => {
    this.setState({ showRoleOperation: !this.state.showRoleOperation })
  }

  toggleStaffOperation = async (role?) => {
    const {
      levelStore: { getEntityList },
    } = this.props
    const { activeLesson } = this.state
    if (role) {
      getEntityList(levelStrategies.PASSABLE_STAFFS, {
        lesson_id: activeLesson.id,
        per_page: 100,
      })

      this.staffOperationModalRef.onPassedRolesSelect(role.id)
      this.setState({ activeRole: role })
    }

    this.staffOperationModalRef.toggleVisible(role)
  }

  handleChangePage = (pageIndex: number) => {
    this.setState(
      {
        filter: {
          ...this.state.filter,
          page: pageIndex,
        },
      },
      () => this.getCheckRoles(),
    )
  }

  onStaffOperationModalRef = ref => {
    this.staffOperationModalRef = ref
  }

  showDeleteConfirm = async (role, index): Promise<any> => {
    const {
      levelStore: {
        getEntityList,
        departmentRolesMeta: {
          pagination: { count, current_page },
        },
      },
    } = this.props
    const isExistDoingStaff = Boolean(role.staff_count)

    confirm({
      title: '角色删除操作',
      content: isExistDoingStaff
        ? '该角色内还有员工在通关，为避免误删，请进入人员列表清空人员后删除，删除后通关情况也会同步清空'
        : '确定删除当前级别下的角色类型吗？',
      onOk: async () => {
        if (!isExistDoingStaff) {
          await this.api.level.deleteCheckRole(role.id)
          this.$message.success(`角色：${role.name}删除成功`)
          await getEntityList(levelStrategies.DEPARTMENT_ROLES, {
            ...this.state.filter,
            page: count - 1 === 0 ? current_page - 1 : current_page,
          })
        }
      },
    })
  }

  render() {
    const {
      levelStore: {
        checkSettingsVisible,
        toggleCheckSettingsModal,
        departmentRoles,
        departmentRolesMeta,
      },
      lessons,
    } = this.props
    const {
      loading,
      showRoleOperation,
      showStaffOperation,
      activeLesson,
      activeRole,
    } = this.state

    const ModalTitle = () => (
      <div>
        <span>部门通关角色配置</span>
        <ButtonGroup>
          {lessons &&
            lessons.map(lesson => (
              <Button
                type={lesson.id === activeLesson.id ? 'primary' : 'default'}
                key={lesson.id}
                onClick={this.switchLesson.bind(this, lesson)}
              >
                {lesson.name}
              </Button>
            ))}
        </ButtonGroup>
        <Button className={styles.addRoleBtn} onClick={this.addRole}>
          新增角色
        </Button>
      </div>
    )

    const columns = [
      {
        title: '进阶级别',
        dataIndex: 'lesson.name',
      },
      {
        title: '角色',
        dataIndex: 'name',
        width: 140,
      },
      {
        title: '角色属性',
        dataIndex: 'category',
      },
      {
        title: '人数',
        dataIndex: 'staff_count',
      },
      {
        title: '使用关卡',
        dataIndex: 'template.name',
      },
      {
        title: '配置操作',
        dataIndex: 'operation',
        key: 'operation',
        render: (text, record, index) => {
          return (
            <div>
              <span
                className={`${styles.operationBtn} ${styles.editRoleBtn}`}
                onClick={this.toggleStaffOperation.bind(this, record)}
              />
              {record.category !== '默认' && (
                <span
                  className={`${styles.operationBtn} ${styles.deleteRoleBtn}`}
                  onClick={this.showDeleteConfirm.bind(this, record, index)}
                />
              )}
            </div>
          )
        },
      },
    ]

    const pagination = departmentRolesMeta && {
      current: departmentRolesMeta.pagination.current_page,
      pageSize: departmentRolesMeta.pagination.per_page,
      total: departmentRolesMeta.pagination.total,
    }

    return (
      <Modal
        wrapClassName={styles.checkSettingsModal}
        width={800}
        closable={false}
        footer={
          <Button
            type={'primary'}
            onClick={() => {
              toggleCheckSettingsModal()
            }}
          >
            关闭
          </Button>
        }
        title={<ModalTitle />}
        visible={checkSettingsVisible}
      >
        <Table
          rowKey={'id'}
          dataSource={departmentRoles}
          columns={columns}
          loading={loading}
          pagination={{
            ...pagination,
            onChange: this.handleChangePage,
          }}
        />
        <RoleOperationModal
          showRoleOperation={showRoleOperation}
          toggleRoleOperation={this.toggleRoleOperation}
          activeLesson={activeLesson}
          getCheckRoles={this.getCheckRoles}
        />
        <StaffOperationModal
          onRef={this.onStaffOperationModalRef}
          activeLesson={activeLesson}
          getCheckRoles={this.getCheckRoles}
          activeRole={activeRole}
          showStaffOperation={showStaffOperation}
          toggleStaffOperation={this.toggleStaffOperation}
        />
      </Modal>
    )
  }
}
